import React, { useEffect, useState } from "react";
import "./OrderHistory.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import { ATS } from "../../../../features/ats/atsSlice";
import { parseJSON, toFix } from "../../../../helpers/commonHelper";
import ButtonTriangleSpinner from "../../../../components/common/ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import { useSelector } from "react-redux";
import { mergeOrderHistoryByOrderId, getOrderHistoryRowKey, isEligibleOrderHistoryRow, resolveOrderQuantity, formatOrderWalletTypeLabel } from "./orderHistoryMerge";
const renderOrderHistoryStatus = item => {
  const qty = resolveOrderQuantity(item);
  const filled = Number(item.filled_amount) || 0;
  const fillRatioPct = qty > 0 && Number.isFinite(filled) ? filled / qty * 100 : null;
  const s = Number(item.status);
  if (s === 1) {
    return <p className="yellow_text">Pending</p>;
  }
  if (s === 3) {
    return <p className="green_text">Completed</p>;
  }
  if (s === 6) {
    return <p className="green_text">Speedbump Validating</p>;
  }
  if (s === 4) {
    return <p className="green_text">
                Partial ({toFix(fillRatioPct ?? 0, 2)}%)
            </p>;
  }
  if (s === 2) {
    const isPartiallyExecuted = fillRatioPct != null && fillRatioPct > 0 && fillRatioPct < 100 && filled > 0;
    if (isPartiallyExecuted) {
      return <p className="red_text">
                    Cancelled (Partial {toFix(fillRatioPct, 2)}%)
                </p>;
    }
    return <p className="red_text">Cancelled</p>;
  }
  return null;
};
const OrderHistoryTable = ({
  order
}) => {
  const [orderHistory, setOrderHistory] = useState([]);
  const [loadMore, setIsLoadMore] = useState(false);
  const [fetchInFlight, setFetchInFlight] = useState(false);
  /** Spinner / Loading label only when Load More is used. */
  const [loadMoreFetching, setLoadMoreFetching] = useState(false);
  const [paginationBody, setPaginationBody] = useState({
    page: 1,
    limit: 10,
    pairName: ''
  });
  const selectedPair = useSelector(state => state.ats.selectedPair);
  const fields = ["Symbol", "Price", "Quantity", "Side", "Order Type", "Wallet Type", "Filled Amount", "Executed Price", "Status"];
  const LIMIT = paginationBody.limit;
  const showLoadMoreFooter = loadMoreFetching || Boolean(loadMore) && !fetchInFlight;
  useEffect(() => {
    if (order && isEligibleOrderHistoryRow(order)) {
      setOrderHistory(prev => mergeOrderHistoryByOrderId([order, ...parseJSON(prev)]));
    }
  }, [order]);
  const getUserOrderHistory = async (mode = "replace") => {
    const appendPage = mode === "append";
    if (appendPage) setLoadMoreFetching(true);
    setFetchInFlight(true);
    try {
      const response = await ATS.fetchUserOrderHistory(paginationBody);
      if (response.status === 200) {
        const batch = response.data?.orderlist ?? [];
        setIsLoadMore(batch.length >= LIMIT);
        if (appendPage) {
          setOrderHistory(prev => mergeOrderHistoryByOrderId([...parseJSON(prev), ...batch]));
        } else {
          setOrderHistory(mergeOrderHistoryByOrderId(batch));
        }
      }
    } finally {
      setFetchInFlight(false);
      if (appendPage) setLoadMoreFetching(false);
    }
  };
  useEffect(() => {
    if (selectedPair) {
      setIsLoadMore(true);
      paginationBody.page = 1;
      const div = document.getElementsByClassName("orderHisoryTable")[0]?.querySelector(".table-responsive");
      if (div && typeof div.scroll === "function") div.scroll(0, 0);
      paginationBody.pairName = selectedPair.pair_key;
      setPaginationBody(paginationBody);
      getUserOrderHistory("replace");
    }
  }, [selectedPair]);
  const onLoadMore = () => {
    if (fetchInFlight) return;
    paginationBody.page += 1;
    setPaginationBody(paginationBody);
    getUserOrderHistory("append");
  };
  return <>
            <div className="orderHisoryTable">
                <CommonTable fields={fields}>
                    {orderHistory?.filter(isEligibleOrderHistoryRow)?.map((item, index) => <tr key={getOrderHistoryRowKey(item) ?? `history-${index}`}>
                                    <td>{`${selectedPair?.otherCurrency?.toUpperCase()}/${selectedPair?.baseCurrency?.toUpperCase()}`}</td>
                                    {/* <td>{`${selectedPair?.name?.toUpperCase()}`}</td> */}
                                    <td>{item.price}</td>
                                    <td>
                                        {resolveOrderQuantity(item)}
                                    </td>
                                    <td>
                                        <span className={item.side === 0 ? "green_text" : "red_text"}>
                                            {item.side === 0 ? 'Buy' : 'Sell'}
                                        </span>
                                    </td>
                                    <td>
                                        <span>{item.type === 0 ? "LIMIT " : "Market "}</span>
                                        {/* <span>{item.advanceOrderType}</span> */}
                                    </td>
                                    <td>{formatOrderWalletTypeLabel(item)}</td>
                                    <td>{item.filled_amount}</td>
                                    <td>{item.executed_price}</td>
                                    <td>{renderOrderHistoryStatus(item)}</td>
                                </tr>)}
                </CommonTable>
                {showLoadMoreFooter ? <div className="tableLoaderBtn">
                        <button className="btn-style black-btn tableLoaderBtn__action w-100" disabled={fetchInFlight || !loadMore} onClick={onLoadMore} type="button" aria-busy={Boolean(loadMoreFetching)}>
                            <span className="tableLoaderBtn__label">
                                {loadMoreFetching ? 'Loading' : 'Load More'}
                            </span>
                            {loadMoreFetching ? <span className="tableLoaderBtn__spinner-inline" aria-hidden="true">
                                    <ButtonTriangleSpinner size={18} />
                                </span> : null}
                        </button>
                    </div> : null}
            </div>
        </>;
};
export default OrderHistoryTable;